import Authorization from "../../../../generics/authorization";
import LinkUtilization from ".";

const pageProps = {
  workflowContainer: true,
  dashlets: [{
    component: LinkUtilization,
    name: "linkUtilization",
    layout: { x: 0, y: 0, w: 12, h: 40 }
  }]
};

const Page = () => (<Authorization pageProps={pageProps} />);

export default Page;
